module.exports = __webpack_public_path__ + "static/logo-5ccb27025c7c8e2f72d45114497826d5.png";